import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import type { AnswerSection } from "@/components/types";
import OverviewItemRenderer from "./OverviewItemRenderer";
import LegalFrameworkItemRenderer from "./LegalFrameworkItemRenderer";
import CaseAnalysisItemRenderer from "./CaseAnalysisItemRenderer";

interface AnswerSectionRendererProps {
  section: AnswerSection;
  onDocumentClick: (documentId: string) => void;
}

const AnswerSectionRenderer = ({ section, onDocumentClick }: AnswerSectionRendererProps) => {
  switch (section.type) {
    case "overview":
      return (
        <div key="overview" className="space-y-6">
          <h3 className="text-2xl max-md:text-xl max-sm:text-lg text-right">תקציר:</h3>
          {section.items && Array.isArray(section.items) ? (
            section.items.map((item, index) => (
              <OverviewItemRenderer key={index} item={item}/>
            ))
          ) : (
            <div className="text-center py-8 text-slate-500">
              <p className="text-sm">אין פריטי תקציר זמינים</p>
            </div>
          )}

          <div className="p-8">
            <div className="flex items-center justify-center">
              <Badge variant="outline" className="text-xs mb-3">
                סוף תקציר
              </Badge>
            </div>
            <Separator className="bg-slate-200" />
          </div>
        </div>
      );

    case "legal_framework":
      return (
        <div key="legal_framework" className="space-y-6">
          <h2 className="text-2xl max-md:text-xl max-sm:text-lg font-semibold text-indigo-900 text-right mb-6">
            {section.title}
          </h2>
          {section.items && Array.isArray(section.items) ? (
            section.items.map((item, index) => (
              <LegalFrameworkItemRenderer 
                key={index} 
                item={item} 
                onDocumentClick={onDocumentClick} 
                index={index}
              />
            ))
          ) : (
            <div className="text-center py-8 text-slate-500">
              <p className="text-sm">אין פריטי מסגרת משפטית זמינים</p>
            </div>
          )}
        </div>
      );

    case "case_analysis":
      return (
        <div key="case_analysis" className="space-y-6">
          <h2 className="text-2xl max-md:text-xl max-sm:text-lg font-semibold text-indigo-900 text-right mb-6">
            {section.title}
          </h2>
          {section.items && Array.isArray(section.items) ? (
            section.items.map((item, index) => (
              <CaseAnalysisItemRenderer 
                key={index} 
                item={item} 
                onDocumentClick={onDocumentClick} 
                index={index}
              />
            ))
          ) : (
            <div className="text-center py-8 text-slate-500">
              <p className="text-sm">אין פריטי ניתוח מקרה זמינים</p>
            </div>
          )}
        </div>
      );

    default:
      return null;
  }
};

export default AnswerSectionRenderer;
